import { render, staticRenderFns } from "./BracketCard.vue?vue&type=template&id=67d533f8&"
import script from "./BracketCard.vue?vue&type=script&lang=js&"
export * from "./BracketCard.vue?vue&type=script&lang=js&"
import style0 from "./BracketCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports